// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import * as React from 'react';
import { Dropdown, IDropdownOption, IDropdownStyles } from 'office-ui-fabric-react';
import { useTranslation } from 'react-i18next';
import Styles from './styles.module.scss';

interface SoftwareSupportProps {
    onSdtToolRanChange: (option: IDropdownOption | undefined) => void;
    onTypeOfResolutionChange: (option: IDropdownOption | undefined) => void;
    sdtToolRan?: IDropdownOption;
    typeOfResolution?: IDropdownOption;
}

export default function softwareSupport(props: SoftwareSupportProps) {
    const { t } = useTranslation();

    const options: IDropdownOption[] = [
        { key: 'yes', text: t('yes') },
        { key: 'no', text: t('no') },
    ];

    const resolutionOptions: IDropdownOption[] = [
        { key: 'simple_resolution', text: t('simple_resolution') },
        { key: 'high_level_resolution', text: t('high_level_resolution') },
    ];

    const dropdownStyles: Partial<IDropdownStyles> = {
        root: { marginTop: 20 },
        dropdown: { width: 300 },
    };

    const resolutionDropdownStyles: Partial<IDropdownStyles> = {
        dropdown: { width: 300 },
        root: {
            marginTop: 20,
            marginLeft: 100,
        },
    };

    function onSdtToolRanChange(event: any, option: IDropdownOption | undefined) {
        props.onSdtToolRanChange(option);
    }

    function onTypeOfResolutionChange(event: any, option: IDropdownOption | undefined) {
        props.onTypeOfResolutionChange(option);
    }

    return (
        <div className={Styles.softwareDropdownContainer}>
            <Dropdown
                id="sdt-tool-ran-id"
                label={t('sdt_tool_ran')}
                options={options}
                styles={dropdownStyles}
                onChange={onSdtToolRanChange}
                required={true}
            />
            <Dropdown
                id="software-resolution-type-id"
                label={t('type_of_resolution')}
                options={resolutionOptions}
                styles={resolutionDropdownStyles}
                onChange={onTypeOfResolutionChange}
                required={true}
            />
        </div>
    );
}